import script from "./FriendshipBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FriendshipBox.vue?vue&type=script&setup=true&lang=ts"

import "./FriendshipBox.vue?vue&type=style&index=0&id=55016dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55016dce"]])

export default __exports__